import * as React from "react";
const NewsView = React.lazy(() => import("./NewsViewContainer"));
const RequestQuotation = React.lazy(() => import("./RequestQuotationContainer"));

export { NewsView, RequestQuotation };
